<template>
  <div class="page-inner r" style="min-height: 100vh;">
    <div class="page-title">
      <h3>{{ $t("message.Абоненты") }}</h3>
      <div class="page-breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/">{{ $t("message.Главная") }}</router-link>
          </li>
          <li class="active breadcrumb-item">{{ $t("message.Абоненты") }}</li>
        </ol>
      </div>
    </div>
    <div id="main-wrapper">
      <b-button :variant="'success'" class="mb-1 float-right" @click="addRow()">
        {{ $t("message.Создать") }}
      </b-button>

      <b-table
        id="device-table"
        :busy.sync="isBusy"
        :items="dataProvider"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filters"
      >
        <template slot="HEAD_id" slot-scope="data">
          <b-form-group label="ID">
            <b-form-input
              @click.native.stop
              size="sm"
              :readonly="isBusy"
              v-debounce="500"
              :value="innerFilter.id"
              @change.native="innerFilter.id = $event.target.value"
              style="width:50px;"
            >
            </b-form-input>
          </b-form-group>
        </template>
        <template slot="HEAD_login" slot-scope="data">
          <b-form-group label="Login">
            <b-form-input
              @click.native.stop
              size="sm"
              :readonly="isBusy"
              v-debounce="500"
              :value="innerFilter.login"
              @change.native="innerFilter.login = $event.target.value"
              style="width:100px;"
            >
            </b-form-input>
          </b-form-group>
        </template>
        <template slot="actions" slot-scope="row" class="actions">
          <!-- We use @click.stop here to prevent a 'row-clicked' event from also happening -->
          <b-button
            size="sm"
            @click.stop="editRow(row.item, row.index, $event.target)"
            class="mr-1"
          >
            <i class="fas fa-edit"></i>
          </b-button>
          <!-- #853
          <b-button
            size="sm"
            @click.stop="deleteRow(row.item, row.index, $event.target)"
          > 
            <i class="fas fa-trash-alt"></i>
          </b-button> 
          -->
        </template>
        <template slot="dates" slot-scope="row">
          {{ row.item.created_at    ? row.item.created_at   : '____-__-__'}}<br />
          {{ row.item.last_seen_at  ? row.item.last_seen_at : '____-__-__'}}<br />
          {{ row.item.expires_at    ? row.item.expires_at   : '____-__-__'}}
        </template>
        <template slot="login" slot-scope="row">
          {{ row.item.login }}<br />
          <span class="text-muted">{{ row.item.comment }}</span>
        </template>
        <template slot="enabled" slot-scope="data">
          <i
            class="fa fa-check"
            aria-hidden="true"
            v-if="data.item.enabled == true"
          ></i>
          <i
            class="fa fa-ban"
            aria-hidden="true"
            v-if="data.item.enabled == false"
          ></i>
        </template>
        <template slot="colocation" slot-scope="data">
          <b-badge class="mr-1" :key="data.item.colocation.id">{{
            data.item.colocation.name
          }}</b-badge>
        </template>
        <template slot="vod" slot-scope="row">
          <b-badge class="mr-1" variant="primary" v-if="row.item.premier_enabled">Premier</b-badge><br>
          <b-badge class="mr-1" variant="dark" v-if="row.item.megogo_enabled">Megogo</b-badge><br>
          <b-badge class="mr-1" variant="secondary" v-if="row.item.vod_enabled">Prime</b-badge>
        </template>
        <template slot="packages" slot-scope="data">
          <b-badge
            class="mr-1"
            v-for="pack in data.item.packages"
            :key="pack.id"
            variant="secondary"
            >{{ pack.name }}</b-badge
          >
          <br>
          <b-badge
            class="mr-1"
            v-for="pack in data.item.vod_packages"
            :key="pack.id"
            variant="info"
            >{{ pack.name }}</b-badge
          >
        </template>
        <template slot="member" slot-scope="data">
          <span v-if="data.item.member">{{ data.item.member.username }}</span>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
      ></b-pagination>
      <b-modal
        id="modalInfo"
        :ok-title="$t('message.Сохранить')"
        :cancel-title="$t('message.Отмена')"
        :title="$t('message.Редактирование_абонента')"
        modal-ok
        modal-cancel
        @ok="handleOk"
        no-close-on-backdrop
      >
        <AccountForm :model="deviceModel"></AccountForm>
      </b-modal>
    </div>
  </div>
</template>

<script>
import AccountForm from "./AccountForm";
import Vue from "vue";
import debounce from "./stolencrap/index";

export default {
  name: "Accounts",
  components: {
    AccountForm
  },
  data() {
    return {
      isBusy: false,
      fields: [
        { key: "id", sortable: true },
        { key: "login", sortable: true },
        {
          key: "enabled",
          sortable: true,
          tdClass: "text-center",
          thClass: "text-center"
        },
        {
          key: "age",
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center"
        },
        {
          key: "max_streams",
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center"
        },
        {
          key: "colocation",
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center"
        },
        {
          key: "packages",
          label:"Packages/Vod packages",
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center"
        },
        {
          key: "vod",
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center"
        },
        {
          key: "dates",
          label: "Created/Seen/Expires",
          sortable: false,
          thClass: "text-center"
        },
        {
          key: "ip_address",
          sortable: false,
          tdClass: "text-center",
          thClass: "text-center"
        },
        {
          key: "member",
          label: "Partner",
          sortable: false,
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "acc_type",
          label: "Type",
          sortable: false,
          thClass: "text-center",
          tdClass: "text-center"
        },
        {
          key: "acc_type_updated_at",
          label: "Type Updated At",
          sortable: false,
          thClass: "text-center",
          tdClass: "text-center"
        },
        { key: "actions", label: "", tdClass: "actions" }
      ],
      deviceModel: {},
      perPage: 10,
      currentPage: 1,
      totalRows: 0,
      innerFilter: {
        id: "",
        login: ""
      }
    };
  },
  methods: {
    created() {},
    dataProvider(ctx) {
      // Here we don't set isBusy prop, so busy state will be handled by table itself
      // this.isBusy = true
      //console.log(ctx)
      let promise = this.$noname.get("accounts", { params: ctx });

      return promise
        .then(data => {
          const items = data.data.items;
          this.totalRows = data.data.total;
          // Here we could override the busy state, setting isBusy to false
          // this.isBusy = false
          return items;
        })
        .catch(this.$noname.HandleError);
    },
    editRow(item, index, button) {
      this.deviceModel = Object.assign({}, item);
      this.$root.$emit("bv::show::modal", "modalInfo", button);
    },
    addRow() {
      this.deviceModel = {};
      this.$root.$emit("bv::show::modal", "modalInfo");
    },
    handleOk(evt) {
      // Prevent modal from closing
      evt.preventDefault();

      if (this.deviceModel.id > 0) {
        this.$noname
          .patch("accounts", this.deviceModel.id, this.deviceModel)
          .then(response => {
            this.$root.$emit("bv::refresh::table", "device-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });

            //window.location.href = redirectUrl
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      } else {
        this.$noname
          .post("accounts", this.deviceModel)
          .then(Reponse => {
            this.$root.$emit("bv::refresh::table", "device-table");
            this.$root.$emit("bv::hide::modal", "modalInfo");

            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Запись_успешно_сохранена"),
              type: "success"
            });
          })
          .catch(error => {
            Vue.notify({
              group: "notify",
              text: this.$i18n.t("message.Ошибка_сохранения") + ":<br>" + error,
              type: "error"
            });
          });
      }
    },
    deleteRow(item, index, button) {
      this.$dialog
        .confirm(this.$i18n.t("message.Действительно_удалить_источник?"))
        .then(response => {
          this.$noname
            .delete("accounts", item.id)
            .then(response => {
              this.$root.$emit("bv::refresh::table", "device-table");
              Vue.notify({
                group: "notify",
                text: this.$i18n.t("message.Запись_успешно_удалена"),
                type: "success"
              });

              //window.location.href = redirectUrl
            })
            .catch(error => {
              Vue.notify({
                group: "notify",
                text:
                  this.$i18n.t("message.Ошибка_удаления_записи") +
                  ":<br>" +
                  error,
                type: "error"
              });
            });
        });
    }
  },
  computed: {
    filters: function() {
      this.currentPage = 1;
      return JSON.stringify(this.innerFilter);
    }
  },
  watch: {
    innerFilters: {
      handler: function() {
        return this.innerFilter;
      },
      deep: true
    }
  },
  directives: { debounce }
};
</script>



// WEBPACK FOOTER //
// src/components/modules/Accounts.vue